export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  AGENTS_CHANGED: 'AGENTS_CHANGED',
  TEAMS_CHANGED: 'TEAMS_CHANGED',
  INBOX_CHANGED: 'INBOX_CHANGED',
  CANNED_RESPONSES_CHANGED: 'CANNED_RESPONSES_CHANGED',
  LABEL_CHANGED: 'LABEL_CHANGED',
};
